<!-- https://www.figma.com/design/K7vDg6el3Bz7MHUdlMREDj/Credit-Conversion-Statuses?node-id=2027-58&p=f&m=dev -->
<template>
  <CardLayout
    button-href="mailto:ulcourses@asu.edu"
    button-text="Contact support"
    title="Hold on! We'll try again shortly."
    :body="cardBody"
    :button-data-layer-event="dataLayerEvent"
    :button-disabled="false"
  >
    <template #art>
      <ArtEarlyRetry />
    </template>
  </CardLayout>
</template>

<script>
import CardLayout from '../ui/CardLayout.vue';
import ArtEarlyRetry from './ArtEarlyRetry.vue';

export default {
  name: 'CardEarlyRetry',
  components: {
    CardLayout,
    ArtEarlyRetry
  },
  data() {
    return {
      /**
       * @type {import('../ui/card-body').CardBody}
       */
      cardBody: {
        blocks: [
          {
            lines: [
              `We encountered a temporary issue while processing your credit request. Our system will automatically retry in a moment. If this continues, please contact support at <a class="card-body-link" href="mailto:ulcourses@asu.edu">ulcourses@asu.edu</a>.`
            ]
          }
        ]
      }
    };
  },
  computed: {
    dataLayerEvent() {
      return {
        event: 'link',
        action: 'click',
        name: 'onclick',
        type: 'external link',
        region: 'main content',
        section: "hold on! we'll try again shortly",
        text: 'contact support',
        component: 'early retry card'
      };
    }
  }
};
</script>
